import http from '@/http/aisea/axios'
const resource = "/enterprises/documents";

export default {
  addFolder (payload) {
    return http.post(`${resource}/folders`, payload);
  },
  deleteFolder (payload) {
    return http.delete(`${resource}/folders`, { data: payload });
  },
  moveFolder (payload) {
    return http.put(`${resource}/folders/move`, payload);
  },
  copyFolder(payload){
    return http.put(`${resource}/folders/copy`, payload);
  },
  renameFolder (payload) {
    return http.put(`${resource}/folders/rename`, payload);
  },
  moveFile (payload) {
    return http.put(`${resource}/files/move`, payload);
  },
  copyFile(payload){
    return http.put(`${resource}/files/copy`, payload);
  },
  renameFile (payload) {
    return http.put(`${resource}/files/rename`, payload);
  },
  important (payload) {
    return http.get(`${resource}/important`, { params: payload });
  },
  latest (payload) {
    return http.get(`${resource}/latest`, { params: payload });
  },
  search (payload) {
    return http.get(`${resource}/search`, { params: payload });
  },
  storageCapacity(payload) {
    return http.get(`${resource}/storage/capacity`, { params: payload });
  },
}